import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b906577"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "coupon_con" }
const _hoisted_3 = { class: "con_l_h" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "价值", -1))
const _hoisted_5 = { class: "con_r_txt" }
const _hoisted_6 = { class: "coupon_club" }

import { ref } from 'vue';
import { ICoupon } from '../types';

interface IProps {
  dataSource: ICoupon;
  choice: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Coupon',
  props: {
    dataSource: null,
    choice: null
  },
  setup(__props: any) {

const props = __props as {
  dataSource: ICoupon;
  choice: any;
};


const data = ref<ICoupon>(props.dataSource);

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["coupon", { actived: data.value.id === props.choice }])
  }, [
    _createElementVNode("img", {
      src: data.value.background
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "con_l",
        style: _normalizeStyle({ color: data.value.color[0] })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(data.value.quota), 1),
          _createTextVNode(" 元 ")
        ]),
        _hoisted_4
      ], 4),
      _createElementVNode("div", {
        class: "con_r",
        style: _normalizeStyle({ color: data.value.color[1] })
      }, [
        _createElementVNode("div", null, _toDisplayString(data.value.card_name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(data.value.describe), 1)
      ], 4)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createVNode(_component_svg_icon, { "icon-class": "coupon_reduction" }),
      _createTextVNode("  已选中该优惠 ")
    ], 512), [
      [_vShow, data.value.id === props.choice]
    ])
  ], 2))
}
}

})